import { ROUTES } from "@/enums/routes";

// utils/navigation.ts
let navigator: (path: string) => void;

export const setNavigator = (navFn: (path: string) => void) => {
  navigator = navFn;
};

export const navigateToLogin = () => {
  if (navigator) {
    navigator(ROUTES.LOGIN);
  }
};
